import { File } from "lucide-react"

import { DocumentOverlay } from "@/components/overlays/DocumentOverlay"
import { Badge } from "@ui/badge"

interface FileBadgeProps {
    id: string
    name: string | undefined
}
export function FileBadge({ id, name }: FileBadgeProps) {
    return (
        <DocumentOverlay document={id}>
            <Badge variant="outline" className='p-2 text-sm text-primary flex-shrink-0 flex items-center gap-2 bg-gray-100 hover:cursor-pointer italic'>
                <File className='size-4' />
                {name || id}
                <span className='text-xs text-muted-foreground'>(click to view details)</span>
            </Badge>
        </DocumentOverlay>
    )
}

export function FileBadgeLight({ id, name }: FileBadgeProps) {
    return (
        <DocumentOverlay document={id}>
            <Badge variant="outline" className='p-1 text-xs text-primary flex-shrink-0 flex items-center gap-2 bg-gray-200 hover:cursor-pointer italic'>
                <File className='size-3' />
                <div>
                    {name || id}
                </div>
            </Badge>
        </DocumentOverlay>
    )
}